import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  changeScope(event) {
    const param = event.target.dataset.param || "scope";
    const value = event.target.value;
    const url = new URL(window.location);
    url.searchParams.set(param, value);
    window.location = url;
  }
}
